import React from 'react';
import { QualitySubmit, GapCard, Attachments, LitePlanNotification } from '~/components/Patient';
import { enumValue, getGapsByCategory, gapShouldShowControl, useSubmissionUploads } from '~/util';

export interface QualityProps {
    patient: PatientType;
    status: number;
    externalUpload?: ExternalAttachmentType | null;
    clearExternalUpload: () => void;
}
export function Quality({
    patient,
    status,
    externalUpload = null,
    clearExternalUpload,
}: QualityProps) {
    const [uploads, setUploads] = React.useState<MediaFileType[]>([]);
    const [loading, setLoading] = React.useState(false);
    useSubmissionUploads(
        patient,
        JSON.stringify(patient.submissions),
        enumValue(['gap', 'type', 'Quality Gap']) as number,
        setUploads,
        setLoading
    );

    return (
        <div>
            {gapShouldShowControl(status, enumValue(['gap', 'type', 'Quality Gap'])) && (
                <div className="row mb-3">
                    <div className="col text-end">
                        <div className="d-inline me-3">
                            <Attachments
                                gapType={enumValue(['gap', 'type', 'Quality Gap']) as number}
                                patientId={patient.id}
                                patientName={`${patient.first_name} ${patient.last_name}`}
                                uploads={uploads}
                                disabled={loading}
                                externalUpload={externalUpload}
                                clearExternalUpload={clearExternalUpload}
                            />
                        </div>
                        <QualitySubmit
                            patient={patient}
                            disabled={loading}
                            attachments={uploads}
                            handleLoading={setLoading}
                        />
                    </div>
                </div>
            )}
            <div className="patient-gaps-container">
                <LitePlanNotification show={patient?.metadata?.SDSVisibility === false} />
                {getGapsByCategory(patient.quality_gaps, status).map(
                    (cat) =>
                        cat.gaps.length > 0 && (
                            <div className="foc-gap-category-container" key={cat.name}>
                                <div>
                                    <div className="h5 fw-bold">{cat.name}</div>
                                </div>
                                <div className="row">
                                    {cat.gaps.map((gap: GapType) => (
                                        <GapCard
                                            gap={gap}
                                            key={gap.id}
                                            patientId={patient.id}
                                            statusFilter={status}
                                        />
                                    ))}
                                </div>
                            </div>
                        )
                )}
            </div>
        </div>
    );
}
